module.exports = __webpack_public_path__ + "img/GY.0d1d3718.svg";